import { render, staticRenderFns } from "./Basket_outline.vue?vue&type=template&id=379ab849&"
import script from "./Basket_outline.vue?vue&type=script&lang=js&"
export * from "./Basket_outline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports